export const OAUTH_PROVIDERS = {
  FACEBOOK: 'FACEBOOK',
  GOOGLE: 'GOOGLE',
  UTAHID: 'UTAHID'
};
